// import React from "react";
import IDynamicFormRow from '../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow';
import { ExtrasDialogForm, IExtrasDialogForm } from "../components/menu/products/ExtrasDialogForm";
import { DeleteItems } from "../yoello-lib/modules/dynamicForms/CustomFormComponents/DeleteItems";
import FormTextBox from '../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox';
// import FormTitle from '../yoello-lib/modules/dynamicForms/FormComponents/FormTitle';

const extraGroupsForm = (t: (key: string) => string, props: IExtrasDialogForm, isEposNow: boolean, isNewItem: boolean , closeAllModals:(path:string)=>void , onFailedInteraction?:Function): IDynamicFormRow[] => {
    let formRows: IDynamicFormRow[] = [
        {
            Component: FormTextBox,
            label: "menu.extras.name_public",
            keyName: "name_public",
            registerOptions:
            {
                required: !isEposNow,
            },
            gridColumnOptions: { formCol: 6 },
            disabled: isEposNow
        },
        // Option supplied dynamically
        {
            Component: FormTextBox,
            label: "menu.extras.name_internal",
            keyName: "name_internal",
            registerOptions:
            {
                required: !isEposNow,
            },
            gridColumnOptions: { formCol: 6 },
            disabled: isEposNow
        },
        // TODO: Make a minmax component
        {
            Component: FormTextBox,
            label: "menu.extras.quantity_min",
            keyName: "quantity_min",
            inputProperties: { type: 'number' },
            registerOptions:
            {
                required: !isEposNow,
                min: 0

            },
            gridColumnOptions: { formCol: 6 },
            disabled: isEposNow
        },
        {
            Component: FormTextBox,
            label: "menu.extras.quantity_max",
            keyName: "quantity_max",
            inputProperties: { type: 'number' },
            registerOptions:
            {
                required: !isEposNow,
                min: 1
            },
            gridColumnOptions: { formCol: 6 },
            disabled: isEposNow
        },
    ];

    if (!isNewItem && !isEposNow) {
        formRows = [...formRows, {
            label: "delete.label",
            Component: DeleteItems,
            formProps: {
                rawProps: props, callAPI: props.callAPI, ParentComponent: ExtrasDialogForm,
                item: props.formData, keyLabel: "extras",
                isArrayModal: true,
                closeAllModalsOnSubmit: true, 
                closeAllModals: ()=>closeAllModals(props.routePath),
                onFailedInteraction:onFailedInteraction
            },
            keyName: "delete",
        }]
    }

    return formRows;
};

export default extraGroupsForm;
